import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { Errors } from '../style';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  question_number: {
    name: 'Question Number'
  },
  assumption_description: {
    name: 'Assumption Description'
  }
};

export function AssumptionsAIF001({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const { rows, columns, onChange } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.ASSUMPTIONS001,
    onChangeFund,
    schema: schema.ASSUMPTIONS001,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.ASSUMPTIONS001?.field_names || [],
    columnLables,
    // @ts-ignore
    order: 14,
    isMultiFunds,
    funds,
    tableName: 'ASSUMPTIONS001',
    onAddColumn,
    onDeleteColumn,
    hasTableOrderNumber: false
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.ASSUMPTIONS?.field_names?.length === 0;

  return (
    <>
      <Errors id="reporttables-assumptions-aif001-errors">
        {isRequiredTable && (
          <li id="reporttables-assumptions-aif001-required-error">
            This section must be completed
          </li>
        )}
      </Errors>

      <Table
        id="reporttables-assumptions-aif001-table"
        // @ts-ignore
        stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        handleChanges={onChange}
        columns={columns}
        rows={rows}
      />
    </>
  );
}
